import { createContext, useContext, useState } from 'react';

const TcpaConsentDbaContext = createContext()

export const TcpaConsentDbaProvider = ({ children }) => {
  const [tcpaConsentDbaContextValue, setTcpaConsentDbaContextValue] = useState({})

  return <>
    <TcpaConsentDbaContext.Provider value={{ tcpaConsentDbaContextValue, setTcpaConsentDbaContextValue }}>
      {children}
    </TcpaConsentDbaContext.Provider>
  </>
}

export const useTcpaConsentDbaContext = () => useContext(TcpaConsentDbaContext);
